module.exports = __webpack_public_path__ + "assets/img/m_head.3e5f60cf.png";